export default __webpack_public_path__ + "static/media/LES.cf6bb1f6.svg";